import QRCodePage from '../../../components/edge/QRCodePage.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class qrCodeBatchSearch extends InlineComponent {
  define() {
    this.component = QRCodePage;
  }
};
